var cov_24oxb3ehms = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tabs/Panel.tsx",
      hash = "2c05d735c4d9ba9cf26c2c3c4c593e6039b2d20e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tabs/Panel.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 7,
          column: 47
        }
      },
      "1": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 16
        }
      },
      "2": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 26
        }
      },
      "3": {
        start: {
          line: 20,
          column: 84
        },
        end: {
          line: 20,
          column: 94
        }
      },
      "4": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 57
        }
      },
      "5": {
        start: {
          line: 21,
          column: 46
        },
        end: {
          line: 21,
          column: 57
        }
      },
      "6": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 27
        }
      },
      "7": {
        start: {
          line: 24,
          column: 18
        },
        end: {
          line: 24,
          column: 94
        }
      },
      "8": {
        start: {
          line: 25,
          column: 22
        },
        end: {
          line: 25,
          column: 94
        }
      },
      "9": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 30,
          column: 12
        }
      },
      "10": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 35
        }
      },
      "11": {
        start: {
          line: 33,
          column: 22
        },
        end: {
          line: 33,
          column: 35
        }
      },
      "12": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 66
        }
      },
      "13": {
        start: {
          line: 39,
          column: 0
        },
        end: {
          line: 39,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 33
          },
          end: {
            line: 17,
            column: 3
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 11
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 19
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 57
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 57
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 8
          },
          end: {
            line: 21,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 8
          },
          end: {
            line: 21,
            column: 17
          }
        }, {
          start: {
            line: 21,
            column: 21
          },
          end: {
            line: 21,
            column: 36
          }
        }, {
          start: {
            line: 21,
            column: 40
          },
          end: {
            line: 21,
            column: 44
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 46
          },
          end: {
            line: 24,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 46
          },
          end: {
            line: 24,
            column: 56
          }
        }, {
          start: {
            line: 24,
            column: 60
          },
          end: {
            line: 24,
            column: 66
          }
        }],
        line: 24
      },
      "3": {
        loc: {
          start: {
            line: 25,
            column: 52
          },
          end: {
            line: 25,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 52
          },
          end: {
            line: 25,
            column: 60
          }
        }, {
          start: {
            line: 25,
            column: 64
          },
          end: {
            line: 25,
            column: 70
          }
        }],
        line: 25
      },
      "4": {
        loc: {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 33,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 33,
            column: 35
          }
        }, {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 33,
            column: 35
          }
        }],
        line: 33
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tabs/Panel.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import List from '../AnimationList';
import { tabsClass } from './styles';
var CollapseList = (cov_24oxb3ehms.s[0]++, List(['collapse'], 'fast'));

var Panel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Panel, _PureComponent);

  var _super = _createSuper2(Panel);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    cov_24oxb3ehms.f[0]++;
    cov_24oxb3ehms.s[1]++;
    _this = _super.call(this, props);
    _this.isPristine = void 0;
    cov_24oxb3ehms.s[2]++;
    _this.isPristine = true;
    return _this;
  }

  _createClass(Panel, [{
    key: "render",
    value: function render() {
      cov_24oxb3ehms.f[1]++;

      var _ref = (cov_24oxb3ehms.s[3]++, this.props),
          children = _ref.children,
          background = _ref.background,
          color = _ref.color,
          isActive = _ref.isActive,
          collapsible = _ref.collapsible,
          collapsed = _ref.collapsed,
          lazy = _ref.lazy;

      cov_24oxb3ehms.s[4]++;

      if ((cov_24oxb3ehms.b[1][0]++, !isActive) && (cov_24oxb3ehms.b[1][1]++, this.isPristine) && (cov_24oxb3ehms.b[1][2]++, lazy)) {
        cov_24oxb3ehms.b[0][0]++;
        cov_24oxb3ehms.s[5]++;
        return null;
      } else {
        cov_24oxb3ehms.b[0][1]++;
      }

      cov_24oxb3ehms.s[6]++;
      this.isPristine = false;
      var style = (cov_24oxb3ehms.s[7]++, Object.assign({
        background: (cov_24oxb3ehms.b[2][0]++, background) || (cov_24oxb3ehms.b[2][1]++, '#fff'),
        color: color
      }, this.props.style));
      var className = (cov_24oxb3ehms.s[8]++, classnames(tabsClass('panel', (cov_24oxb3ehms.b[3][0]++, isActive) && (cov_24oxb3ehms.b[3][1]++, 'show')), this.props.className));
      var result = (cov_24oxb3ehms.s[9]++,
      /*#__PURE__*/
      React.createElement("div", {
        style: style,
        className: className,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28,
          columnNumber: 7
        }
      }, children));
      cov_24oxb3ehms.s[10]++;

      if (!collapsible) {
        cov_24oxb3ehms.b[4][0]++;
        cov_24oxb3ehms.s[11]++;
        return result;
      } else {
        cov_24oxb3ehms.b[4][1]++;
      }

      cov_24oxb3ehms.s[12]++;
      return (
        /*#__PURE__*/
        React.createElement(CollapseList, {
          show: !collapsed,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35,
            columnNumber: 12
          }
        }, result)
      );
    }
  }]);

  return Panel;
}(PureComponent);

Panel.isTabPanel = void 0;
cov_24oxb3ehms.s[13]++;
Panel.isTabPanel = true;
export default Panel;